<template lang="html">
    <d-list-group flush>
      <d-list-group-item class="p-0">
        <d-form @submit.prevent="submit()">
          <d-form-row>

            <!-- Presentation -->
            <d-col md="12" class="form-group">
              <label for="name">Apresentação</label>
              <editor ref="presentation" :model.sync="model.presentation" placeholder="Apresentação nos pdfs"></editor>
            </d-col>

          </d-form-row>

          <d-form-row>
            <quotation-deadlines :model.sync="model" />
          </d-form-row>

          <d-form-row>

            <!-- Send Message -->
            <d-col md="12" class="form-group">
              <label>Detalhes do orçamento</label>
              <editor ref="details" :model.sync="model.quotationDetails"/>
            </d-col>

          </d-form-row>

          <d-form-row>

            <!-- Send Message -->
            <d-col md="12" class="form-group">
              <label>Mensagem de envio <span class="text-muted">(corpo do e-mail)</span></label>
              <editor ref="send" :model.sync="model.sendMessage"/>
            </d-col>

          </d-form-row>

          <d-form-row>

            <!-- Send Message -->
            <d-col md="12" class="form-group">
              <label>Mensagem de envio <span class="text-muted">(corpo do whatsapp)</span></label>
              <textarea class="form-control" rows="10" v-model="model.sendMessageWhats"></textarea>
            </d-col>

          </d-form-row>

          <d-form-row>

            <!-- Send Message -->
            <d-col md="12" class="form-group">
              <label>Mensagem de envio <span class="text-muted">(notificação de novos arquivos)</span></label>
              <editor ref="details" :model.sync="model.sendMessageNewFilesUpload"/>
            </d-col>

          </d-form-row>

          <d-form-row>
            <d-button type="submit" class="btn-primary">Salvar</d-button>
          </d-form-row>
        </d-form>

      </d-list-group-item>
    </d-list-group>
  <!-- </d-card> -->
</template>

<script>
import { mapActions } from 'vuex';
import Editor from '_shared/Editor.vue';
import Events from '_utils/events';
import SettingsService from '_services/rest/modules/settings';
import QuotationDeadlines from '_modules/quotation/components/QuotationDeadlines.vue';
import formatErrors from '_common/mixins/FormatErrors';
import { _LOAD_MODEL_MESSAGE_, MESSAGES } from './SettingsModel';

export default {
  name: 'messages-form',
  mixins: [formatErrors],
  components: {
    Editor,
    QuotationDeadlines,
  },
  data() {
    return {
      model: { ...MESSAGES },
    };
  },
  watch: {},
  methods: {
    ...mapActions([
      'activeAlert',
      'getSettings',
    ]),
    submit() {
      this.loading = true;
      SettingsService.saveOptions(this.model, 'message')
        .then(() => {
          this.getSettings();
          this.activeAlert({ message: 'Mensagens salvas com sucesso', theme: 'success' });
        })
        .catch(this.showError)
        .finally(this.loading = false);
    },
  },
  mounted() {
    Events.$on(_LOAD_MODEL_MESSAGE_, newValue => {
      this.model = { ...newValue };
    });
  },
};
</script>

<style lang="scss" scoped>
.text-muted { font-size: 12px;}
</style>
